import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-activity-catalogue',
  templateUrl: './activity-catalogue.component.html',
  styleUrls: ['./activity-catalogue.component.css']
})
export class ActivityCatalogueComponent implements OnInit {

  timezoneInfo: boolean = false;
  selectedTimeZone: string = "";
  localTimeZone: string = "";

  constructor() { }

  ngOnInit() {
    this.checkTimezone();

    this.selectedTimeZone = localStorage.getItem('selectedTimeZone');
    this.localTimeZone = localStorage.getItem('localTimeZone');
  }

  checkTimezone() {
    var dt = new Date();
    var offset = dt.getTimezoneOffset();
    var timezone: any = parseInt(localStorage.getItem("timezone"));

    if (Math.abs(offset) !== Math.abs(timezone)) {      
      this.timezoneInfo = true;
    } else {      
      this.timezoneInfo = false;
    }
  }

}
